import { FC, FormEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { locationOfCourse } from '@les-sherpas/sherpas-toolbox';

import FilterSection from '@/components/Search/components/Filters/common/FilterSection/FilterSection';
import {
  indifferentLocationOfCourse,
  SidePanelFilters,
} from '@/components/Search/types';
import { Radio } from '@/designSystem/Form/Radio/Radio';

import messages from './messages';

type Props = {
  handleChange: FormEventHandler<HTMLDivElement>;
  value: SidePanelFilters['courseLocation'];
};

const LocationFilter: FC<Props> = ({ handleChange, value }) => {
  const { formatMessage } = useIntl();

  return (
    <FilterSection title={formatMessage(messages.title)}>
      <Radio
        id={`filter_${indifferentLocationOfCourse}`}
        name={indifferentLocationOfCourse}
        isChecked={value === indifferentLocationOfCourse}
        onChange={handleChange}
      >
        <FormattedMessage {...messages.indifferent} />
      </Radio>
      <Radio
        id={`filter_${locationOfCourse.online}`}
        name={locationOfCourse.online}
        isChecked={value === locationOfCourse.online}
        onChange={handleChange}
      >
        <FormattedMessage {...messages.online} />
      </Radio>
      <Radio
        id={`filter_${locationOfCourse.atHome}`}
        name={locationOfCourse.atHome}
        isChecked={value === locationOfCourse.atHome}
        onChange={handleChange}
      >
        <FormattedMessage {...messages.atHome} />
      </Radio>
    </FilterSection>
  );
};

export default LocationFilter;
